/** Production native adapter. All algorithms are the canonical provider-free leaves. */
import { preserveSceneGenSpec, sceneGenSpecFingerprint, baselineStampSceneGenSpec,
  splitSceneGenSpecForPiece, stampSceneGenSpec, isSceneGenSpecStale } from '../../../../src/lib/agent/scene-gen-spec-semantics';
import { sceneSpecDurationBounds, sceneSpecDurationBlocked } from '../../../../src/lib/agent/scene-spec-duration';
import { applySceneSpecToRegenFields, sceneSpecAnchorMode } from '../../../../src/lib/agent/scene-spec-regen-core';
import { videoRetouchEligibility, omniRetouchEstimate, omniRetouchPromptOf, videoRetouchFreeTextIssue } from '../../../../src/lib/omni-video-retouch-core';
import type { SceneGenerationSemantics } from '../../protocol/source-scene-generation';
export const nativeSceneGenerationSemantics = {
  preserveSceneGenSpec, sceneGenSpecFingerprint, baselineStampSceneGenSpec,
  splitSceneGenSpecForPiece, stampSceneGenSpec, isSceneGenSpecStale,
  sceneSpecDurationBounds, sceneSpecDurationBlocked, applySceneSpecToRegenFields,
  sceneSpecAnchorMode, videoRetouchEligibility, omniRetouchEstimate,
  omniRetouchPromptOf, videoRetouchFreeTextIssue,
} satisfies SceneGenerationSemantics & {
  baselineStampSceneGenSpec: typeof baselineStampSceneGenSpec;
  splitSceneGenSpecForPiece: typeof splitSceneGenSpecForPiece;
  stampSceneGenSpec: typeof stampSceneGenSpec;
  isSceneGenSpecStale: typeof isSceneGenSpecStale;
};
